import React, { Component } from 'react';
import Photos from '../../../../../commonModules/interface/input-files';
import InputText, { TextArea, InputSelect, InputSelectMagasin } from '../../../../../commonModules/interface/form-input-inline';
import { Box, Button } from '@material-ui/core';
import Dialog from '../../../../../commonModules/interface/Dialog';

class NewRepairAction extends Component {
    state = { 
        errors:{
            comments: "",
            next_status: ""
        }
    }
   
    validate = () => {
        const required = ["comments", "next_status"]
        let noErrors = true
        let errors = {}
        required.map( field => {
            if (this.props[field] === "" ){
                errors[field] = "Veuillez remplir ce champ"
                noErrors = false
            } else {
                errors[field] = ""
            }
        })
        
        this.setState({errors})
        if(noErrors){
            this.props.submitAll()            
        }
    }
    render() {
       
        return (
            <Dialog
                block={true}
                title="Nouvelle action"
                close={this.props.closeForms}
                submitAction={this.validate}
            >
                <Box>
                    <TextArea
                        placeholder="Achat de piéce, test technique ..." 
                        rows={4}
                        value={this.state.comments} 
                        name="comments" 
                        onChange={this.props.handleChange}
                        title="Description"
                        required
                    />

                    <InputText 
                        value={this.state.price} 
                        name="price" 
                        onChange={this.props.handleChange} 
                        type="number"
                        title="Coût de l'opération"
                    />

                    <InputSelectMagasin
                        options={[
                            {value:"IN_REPAIR", label:"En cours de réparation"},
                            {value:"REPAIRED", label:"Réparé"},
                            {value:"HS", label:"Irréparable"},
                        ]}
                        value={this.props.next_status_display}
                        onChange={ option => this.props.handleSelect(option,"next_status")}
                        // isOptionDisabled={ option => option.disabled === true}
                        label="Etat après opération"
                        required
                        error={this.state.errors.next_status}
                    />    

                    <Box p={1}>
                        {/* <h5> <span>Joindre Fichier(s)</span> </h5> */}
                        
                        <Photos photoList={this.props.setFiles} photos={this.props.files === null ? [] : this.props.files } file/>
                    </Box>
                
                    {/* <Button variant="contained" color="secondary" onClick={this.validate}>Envoyer</Button> */}
                </Box>
            </Dialog>
        );
    }
}

export default NewRepairAction;
